import HomeView from '@/views/HomeView.vue'
import Sidebar from '@/components/nav/NavComonents.vue'

export default [
    {
        path: '/petCaregiver',
        name: '宠托师管理',
        meta: {
            title: "宠托师管理",
        },
        redirect: '/petCaregiver/petList',
        leaf: false, //是否为单节点，增加属性
        menuShow: true,
        component: HomeView,
        icoClass: 'el-icon-user',
        children: [
            {
                path: '/petCaregiver/petList',
                name: "宠托师列表",
                meta: {
                    title: "宠托师列表",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    // default: () => import('@/views/petCaregiver/petList/index.vue'),
                    default: () => import('@/views/pet/torr/petList/index.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/petCaregiver/singer',
                name: "宠托师详情",
                meta: {
                    title: "宠托师详情",
                    isDestroy: true
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: false,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/pet/torr/petList/singer.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/petCaregiver/petAudit',
                name: "宠托师审核",
                meta: {
                    title: "宠托师审核",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/pet/torr/petAudit/index.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/petCaregiver/petAuditSinger',
                name: "宠托师审核详情",
                meta: {
                    title: "宠托师审核详情",
                    isDestroy: true
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: false,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/pet/torr/petAudit/singer.vue'),
                    sidebar: Sidebar
                }
            },
            // {
            //     path: '/petCaregiver/petNotice',
            //     name: "宠托师须知",
            //     meta: {
            //         title: "宠托师须知",
            //     },
            //     // leaf: true, //是否为单节点，增加属性
            //     menuShow: true,
            //     icoClass: 'el-icon-user',
            //     components: {
            //         default: () => import('@/views/pet/torr/notice/index.vue'),
            //         sidebar: Sidebar
            //     }
            // },
            {
                path: '/petCaregiver/petBasic',
                name: "宠托师基础服务",
                meta: {
                    title: "宠托师基础服务",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/pet/torr/basic/index.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/petCaregiver/petUpgrade',
                name: "宠托师升级服务",
                meta: {
                    title: "宠托师升级服务",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/pet/torr/upgrade/index.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/petCaregiver/petGrade',
                name: "宠托师等级设置",
                meta: {
                    title: "宠托师等级设置",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/pet/torr/grade/index.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/petCaregiver/infoSet',
                name: "宠托师基础配置",
                meta: {
                    title: "宠托师基础配置",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/pet/torr/infoSet/index.vue'),
                    sidebar: Sidebar
                }
            },
        ]
    },
    {
        path: '/carPetgiver',
        name: '洗护师管理',
        meta: {
            title: "洗护师管理",
        },
        redirect: '/carPetgiver/petList',
        leaf: false, //是否为单节点，增加属性
        menuShow: true,
        component: HomeView,
        icoClass: 'el-icon-user',
        children: [
            {
                path: '/carPetgiver/petList',
                name: "洗护师列表",
                meta: {
                    title: "洗护师列表",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    // default: () => import('@/views/carPetgiver/petList/index.vue'),
                    default: () => import('@/views/pet/care/petList/index.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/carPetgiver/singer',
                name: "洗护师详情",
                meta: {
                    title: "洗护师详情",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: false,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/pet/care/petList/singer.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/carPetgiver/petAudit',
                name: "洗护师审核",
                meta: {
                    title: "洗护师审核",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/pet/care/petAudit/index.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/carPetgiver/petAuditSinger',
                name: "洗护师审核详情",
                meta: {
                    title: "洗护师审核详情",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: false,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/pet/care/petAudit/singer.vue'),
                    sidebar: Sidebar
                }
            },
            // {
            //     path: '/carPetgiver/petNotice',
            //     name: "洗护师须知",
            //     meta: {
            //         title: "洗护师须知",
            //     },
            //     // leaf: true, //是否为单节点，增加属性
            //     menuShow: true,
            //     icoClass: 'el-icon-user',
            //     components: {
            //         default: () => import('@/views/pet/care/notice/index.vue'),
            //         sidebar: Sidebar
            //     }
            // },
            {
                path: '/carPetgiver/petBasic',
                name: "洗护师基础服务",
                meta: {
                    title: "洗护师基础服务",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/pet/care/basic/index.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/carPetgiver/petUpgrade',
                name: "洗护师升级服务",
                meta: {
                    title: "洗护师升级服务",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/pet/care/upgrade/index.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/carPetgiver/petGrade',
                name: "洗护师等级设置",
                meta: {
                    title: "洗护师等级设置",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/pet/care/grade/index.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/carPetgiver/infoSet',
                name: "洗护师基础配置",
                meta: {
                    title: "洗护师基础配置",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/pet/care/infoSet/index.vue'),
                    sidebar: Sidebar
                }
            },
        ]
    }
]